<h3 mat-dialog-title class="text-center">Holding Detail</h3>
<br />

<div mat-dialog-content>
  <mat-tab-group *ngIf="holdDetails">
    <mat-tab [label]="holdDetails?.tabHeaders[0]" *ngIf="holdDetails?.tabHeaders[0]" class="tab0">
      <div>
        <table>
          <tr *ngFor="let item of holdDetails?.libraryInfo" class="spaceUnder">
            <td>{{ item?.label }}</td>
            <td *ngIf="typeOf(item?.value) === 'string'" class="str">{{ item?.value }}</td>
            <td *ngIf="typeOf(item?.value) === 'object'" class="obj">
              <!-- <pre>{{item | json}}</pre>
              <pre>address 1: - {{item.value.address1 | json}}</pre> -->
              <span *ngIf="item?.fieldId === 'Address'">
                <div *ngIf="item.value?.address1 && item.value?.address1 !== ''">
                  Address 1: {{ item.value?.address1 }}
                </div>
                <div *ngIf="item.value?.address2 && item.value?.address2 !== ''">
                  Address 2: {{ item.value?.address2 }}
                </div>
                <div *ngIf="item.value?.city && item.value?.city !== ''">
                  City: {{ item.value?.city }}
                </div>
                <div *ngIf="item.value?.state && item.value?.state !== ''">
                  State: {{ item.value?.state }}
                </div>
                <div *ngIf="item.value?.zipCode && item.value?.zipCode !== ''">
                  Zip Code: {{ item.value?.zipCode }}
                </div>
              </span>
              <span *ngIf="item?.fieldId === 'ShipToAddress'">
                <div *ngIf="item.value?.name && item.value?.name !== ''">
                  Name: {{ item.value?.name }}
                </div>
                <div *ngIf="item.value?.address1 && item.value?.address1 !== ''">
                  Address 1: {{ item.value?.address1 }}
                </div>
                <div *ngIf="item.value?.address2 && item.value?.address2 !== ''">
                  Address 2:{{ item.value?.address2 }}
                </div>
                <div *ngIf="item.value?.city && item.value?.city !== ''">
                  City:{{ item.value?.city }}
                </div>
                <div *ngIf="item.value?.state && item.value?.state !== ''">
                  State:{{ item.value?.state }}
                </div>
                <div *ngIf="item.value?.zipCode && item.value?.zipCode !== ''">
                  Zip Code:{{ item.value?.zipCode }}
                </div>
              </span>
            </td>
            <td *ngIf="typeOf(item?.value) === 'array'" class="array">
              <span *ngIf="item?.fieldId === 'HolidayList'">
                <div *ngFor="let x of item?.value">
                  <span *ngIf="x?.startDate && x.startDate !== '' && x.endDate && x.endDate !== ''">
                    <div>Start Date: {{ x?.startDate }}</div>
                    <div>End Date: {{ x?.endDate }}</div>
                  </span>
                  <br />
                </div>
              </span>
            </td>
          </tr>
        </table>
      </div>
    </mat-tab>

    <mat-tab [label]="holdDetails?.tabHeaders[1]" *ngIf="holdDetails?.tabHeaders[1]" class="tab1">
      <table>
        <thead>
          <tr>
            <td *ngFor="let item of holdDetails.shipping.headers">
              <span *ngIf="item !== '' && item !== null">{{ item }}</span>
              <span *ngIf="item === '' || item === null">&nbsp;</span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of holdDetails.shipping.items" class="spaceUnder">
            <td *ngIf="item?.shippingMethod !== null">{{ item?.shippingMethod }}</td>
            <td *ngIf="item?.shippingMethod === null">&nbsp;</td>
            <td *ngIf="item?.materials !== null">{{ item?.materials }}</td>
            <td *ngIf="item?.materials === null">&nbsp;</td>
            <td *ngIf="item?.willShip !== null">{{ item?.willShip }}</td>
            <td *ngIf="item?.willShip === null">&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </mat-tab>

    <mat-tab [label]="holdDetails?.tabHeaders[2]" *ngIf="holdDetails?.tabHeaders[2]" class="tab2">
      <table>
        <thead>
          <tr>
            <td *ngFor="let item of holdDetails.illAcceptance.headers">
              <span *ngIf="item !== '' && item !== null">{{ item }}</span>
              <span *ngIf="item === '' || item === null">&nbsp;</span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of holdDetails.illAcceptance.items" class="spaceUnder">
            <td *ngIf="item?.illAcceptanceMethods !== null">{{ item?.illAcceptanceMethods }}</td>
            <td *ngIf="item?.illAcceptanceMethods === null">&nbsp;</td>
            <td *ngIf="item?.illAcceptILLBy !== null">{{ item?.illAcceptILLBy }}</td>
            <td *ngIf="item?.illAcceptILLBy === null">&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </mat-tab>

    <mat-tab [label]="holdDetails?.tabHeaders[3]" *ngIf="holdDetails?.tabHeaders[3]">
      <table>
        <thead>
          <tr>
            <td *ngFor="let item of holdDetails.copies.headers">
              <span *ngIf="item !== '' && item !== null">{{ item }}</span>
              <span *ngIf="item === '' || item === null">&nbsp;</span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of holdDetails.copies.items" class="spaceUnder">
            <td *ngIf="item?.copyies !== null">{{ item?.copyies }}</td>
            <td *ngIf="item?.copyies === null">&nbsp;</td>
            <td *ngIf="item?.photoCopy !== null">{{ item?.photoCopy }}</td>
            <td *ngIf="item?.photoCopy === null">&nbsp;</td>
            <td *ngIf="item?.fax !== null">{{ item?.fax }}</td>
            <td *ngIf="item?.fax === null">&nbsp;</td>
            <td *ngIf="item?.arielEmailOther !== null">{{ item?.arielEmailOther }}</td>
            <td *ngIf="item?.arielEmailOther === null">&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </mat-tab>
  </mat-tab-group>
</div>
<mat-dialog-actions align="end">
  <button
    role="button"
    type="button"
    aria-label="Place Hold"
    mat-raised-button
    cdkFocusInitial
    class="popup-btn save-btn"
    (click)="dialogRef.close('yes')"
  >
    Close
  </button>
</mat-dialog-actions>
